import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { mapSlideIdsToIndices, viewSlideById, viewSlideByIndex } from "./DOM";

const useSwiperNavigation = (swiperInstance, options = {}) => {
  const location = useLocation();
  const { skipScrollOnPaths = [] } = options;

  useEffect(() => {
    const map = mapSlideIdsToIndices(swiperInstance);

    const navigateToSlide = (hash, search) => {
      const slideHash = hash.replace("#", "");
      const pathname = location.pathname;

      const shouldSkipDefaultScroll = skipScrollOnPaths.some((prefix) => pathname.startsWith(prefix)) && !slideHash;

      setTimeout(() => {
        if (swiperInstance.current) {
          if (slideHash && map[slideHash] !== undefined) {
            viewSlideById(swiperInstance, map, slideHash);
          } else if (!search && !shouldSkipDefaultScroll) {
            viewSlideByIndex(swiperInstance, 0);
          }
        }
      }, 250);
    };

    navigateToSlide(window.location.hash, window.location.search);

    const handleHashChange = () => {
      navigateToSlide(window.location.hash, window.location.search);
    };

    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [location, skipScrollOnPaths]);
};

export default useSwiperNavigation;
